"use strict";

exports.__esModule = true;
var ramda_1 = require("ramda");
var driftTypes_1 = require("../../utils/driftTypes");
var utils_1 = require("../utils");
var rbac_1 = require("./rbac");
var generateAppConfig = function (user) {
  if (utils_1.getIsRbacUser(user)) {
    return rbac_1["default"](user);
  }
  var config = {};
  var scopes = user.scopes,
    gates = user.gates;
  var isVideoUserOnly = utils_1.getIsVideoUserOnly(scopes);
  var isOrgAdmin = utils_1.getIsOrgAdmin(scopes);
  var isCalendarUser = utils_1.getIsCalendarUser(scopes, gates);
  var isBotsV2User = utils_1.getIsBotsV2User(gates);
  var hasConversationFreeOrg = utils_1.getConversationFreeOrg(gates);
  config = ramda_1.set(ramda_1.lensProp('hasNoParticipants'), scopes.includes(driftTypes_1.DriftScopesIF.convoNOPARTICIPANTS), config);
  config = ramda_1.set(ramda_1.lensProp('hasAllConversations'), scopes.includes(driftTypes_1.DriftScopesIF.convoALL) || scopes.includes(driftTypes_1.DriftScopesIF.org_admin), config);
  config = ramda_1.set(ramda_1.lensProp('isVideoUserOnly'), isVideoUserOnly, config);
  config = ramda_1.set(ramda_1.lensProp('hasMyConversations'), true, config);
  config = ramda_1.set(ramda_1.lensProp('hasAbilityToTag'), !isCalendarUser, config);
  config = ramda_1.set(ramda_1.lensProp('hasEditableTags'), !isCalendarUser, config);
  // Static Copy for different users
  if (isVideoUserOnly) {
    config = ramda_1.set(ramda_1.lensProp('mySlicesHeaderCopy'), 'My Video Conversations', config);
  } else if (isCalendarUser) {
    config = ramda_1.set(ramda_1.lensProp('mySlicesHeaderCopy'), 'My Meeting Conversations', config);
  } else {
    config = ramda_1.set(ramda_1.lensProp('mySlicesHeaderCopy'), 'My Open Conversations', config);
  }
  // Conversation slices
  if (isVideoUserOnly || isCalendarUser) {
    config = ramda_1.set(ramda_1.lensProp('hasFilteredConversationsList'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasAbm'), !!gates.ABM, config);
    config = ramda_1.set(ramda_1.lensProp('hasTargetSlice'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasLiveSlice'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hideMyConversationsSliceWhenEmpty'), true, config);
    if (isVideoUserOnly) {
      config = ramda_1.set(ramda_1.lensProp('hasClosedOnlySlice'), true, config);
    } else {
      config = ramda_1.set(ramda_1.lensProp('hasClosedOnlySlice'), false, config);
    }
  } else {
    // else member or admin
    config = ramda_1.set(ramda_1.lensProp('hasFilteredConversationsList'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasAbm'), !!gates.ABM, config);
    config = ramda_1.set(ramda_1.lensProp('hasTargetSlice'), !!gates.ABM && !!gates.has_visitor_presence && !!gates.has_target_slice, config);
    config = ramda_1.set(ramda_1.lensProp('hasLiveSlice'), !!gates.has_inbox_visitor_presence, config);
    config = ramda_1.set(ramda_1.lensProp('hasClosedOnlySlice'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hideMyConversationsSliceWhenEmpty'), false, config);
  }
  /*** Composer ***/
  if (isCalendarUser) {
    config = ramda_1.set(ramda_1.lensProp('hasComposer'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasMeetingsInComposer'), false, config);
  } else if (isVideoUserOnly) {
    config = ramda_1.set(ramda_1.lensProp('hasComposer'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasMeetingsInComposer'), false, config);
  } else {
    config = ramda_1.set(ramda_1.lensProp('hasComposer'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasMeetingsInComposer'), true, config);
  }
  /*** Statuses ***/
  // convo status dropdown
  config = ramda_1.set(ramda_1.lensProp('hasConversationStatusDropdown'), !isCalendarUser, config);
  if (isVideoUserOnly) {
    config = ramda_1.set(ramda_1.lensProp('hasCloseAndLeaveStatusOption'), false, config);
    config = ramda_1.set(ramda_1.lensProp('statusOptions'), ['OPEN', 'CLOSED'], config);
  } else {
    config = ramda_1.set(ramda_1.lensProp('hasCloseAndLeaveStatusOption'), true, config);
    config = ramda_1.set(ramda_1.lensProp('statusOptions'), ['OPEN', 'PENDING', 'CLOSED'], config);
  }
  // AgentStatusTray
  config = ramda_1.set(ramda_1.lensProp('hasAgentStatusTray'), !(isVideoUserOnly || isCalendarUser), config);
  // Drift availability
  config = ramda_1.set(ramda_1.lensProp('hasDriftAvailability'), !(isVideoUserOnly || isCalendarUser), config);
  config = ramda_1.set(ramda_1.lensProp('hasWidgetInstallBanner'), !(isVideoUserOnly || isCalendarUser), config);
  /*** Contact Sidebar ***/
  // LinkedIn Sales Navigator Access
  config = ramda_1.set(ramda_1.lensProp('hasEnabledLinkedInSalesNavigator'), !isVideoUserOnly, config);
  // Convo details sidebar
  if (isVideoUserOnly || isCalendarUser) {
    config = ramda_1.set(ramda_1.lensProp('hasHyperlinkedContactName'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasLeadActions'), false, config);
  } else {
    config = ramda_1.set(ramda_1.lensProp('hasHyperlinkedContactName'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasLeadActions'), true, config);
  }
  // Full timeline activity button
  config = ramda_1.set(ramda_1.lensProp('hasFullActivityTimelineButton'), !isVideoUserOnly, config);
  // Show subnav to org admins with insights
  config = ramda_1.set(ramda_1.lensProp('showSubnav'), !!gates.has_insights && isOrgAdmin, config);
  /*** Popover ***/
  if (isVideoUserOnly || isBotsV2User || hasConversationFreeOrg || isCalendarUser) {
    config = ramda_1.set(ramda_1.lensProp('hasNotifications'), false, config);
  } else {
    // else member, admin, calendar-only
    config = ramda_1.set(ramda_1.lensProp('hasNotifications'), true, config);
  }
  if (!isVideoUserOnly && !isCalendarUser) {
    config = ramda_1.set(ramda_1.lensProp('hasSearch'), true, config);
  }
  return config;
};
exports["default"] = generateAppConfig;